// extracted by mini-css-extract-plugin
export var active = "_cz-7";
export var blink = "_cz-8";
export var dropDownSelector = "_cz-4";
export var dropDownWrapper = "_cz-3";
export var fakeCursor = "_cz-6";
export var fontSizeButton = "_cz-9";
export var formQuillEditor = "_cz-0";
export var pressed = "_cz-a";
export var qlBlank = "_cz-1";
export var textFormattingToolbar = "_cz-2";
export var textToolbarOption = "_cz-5";